// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1EkOv","alert":"SettungsInbox_alert__1GSOT"};